/* gl_chosen.module.js */

"use strict";
const angular = require("angular");

module.exports = angular.module("gl_chosen", []);


/* Generated Dependencies */
module.exports.directive("chosen", require('././directives/chosen.directive.js'));